import { useEffect, useState } from 'react';

// Keep in sync with the `mobile` mixin in components/breakpoints/_breakpoints.scss.
export const mobileMaxWidth = 767;

export const isMobileWidth = (width: number) => width <= mobileMaxWidth;

export const useMobile = () => {

    const [isMobile, setMobile] = useState(determineIfMobile());

    useEffect(() => {
        if (process.env.REACT_APP_TO_BUILD !== 'website-server') {
            const onResize = () => setMobile(determineIfMobile());
            onResize();
            window.addEventListener('resize', onResize);
            return () => window.removeEventListener('resize', onResize);
        }
    }, []);

    return isMobile;
};

const determineIfMobile = () => {

    if (process.env.REACT_APP_TO_BUILD !== 'website-server') {
        return isMobileWidth(window.innerWidth);
    }

    return false;
};